import {baseRouter} from '@/router'
import router from '@/router'

const state = {
  navTab: [],
  base: '',
  navType: 'add',
}
const mutations = {
  SET_NAVTAB: (state, data) => {
    state.navTab = data
  },
  SET_BASE: (state, data) => {
    state.base = data
  },
  SET_NAVTYPE: (state, data) => {
    state.navType = data
  },
}
const actions = {
  setNavTab({dispatch, commit, state}, data) {
    return new Promise((resolve, reject) => {
      // console.log(data, 'data')
      let nav = state.navTab
      let base = data.base || state.base
      // let toPath = data.route && data.route.meta.activeNav || data.route.path
      if (data.base) {
        commit('SET_BASE', data.base)
      }
      if (data.type == 'add' && state.navType == 'add') {
        let hasIndex = state.navTab.findIndex(item => {
          let path = item.meta.activeNav || item.path
          return path == data.route.path
        })
        let hasBase = data.route.path.indexOf(base)
        if (hasIndex == -1 && hasBase == 0) {
          nav.push(data.route)
          dispatch('catchComponents/changeCatchComponents', data.route.name, {root: true})
        } else {
          // console.log('原有',nav[hasIndex].path)
          // console.log('点击',data.route.path)
          // nav[hasIndex].path = data.route.path
        }
      } else {
        nav.splice(0, nav.length)
        dispatch('catchComponents/delAll', [], {root: true})
      }
      commit('SET_NAVTAB', nav)
      resolve(nav)
    })
  },
  closeNavTab({dispatch, commit, state}, index) {
    return new Promise((resolve, reject) => {
      let nav = state.navTab
      let name = nav[index].name
      if (nav.length > 1) {
        if (nav[index].fullPath == router.history.current.fullPath) {
          router.replace({
            path: nav[index - 1].path,
          })
        }
        dispatch('catchComponents/delCatchComponents', name, {root: true})
        nav.splice(index, 1);
        commit('SET_NAVTAB', nav)
      }
      resolve(nav)
    })
  },
  closeAllTab({dispatch, commit, state}) {
    router.replace({
      path: '/'
    })
    dispatch('changeNavType', 'reset')
    commit('SET_NAVTAB', [])
    commit('SET_BASE', '')
  },
  changeNavType({commit, state}, data) {
    commit('SET_NAVTYPE', data)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/navTab.js